export const environment = {
  production: false,
  baseUrl: 'https://tenant.dev.tapgo.ch/app/v1/', // Tenant mgmt API
  customerPanelUrl: 'https://menu.dev.tapgo.ch/',
};
